import { render, staticRenderFns } from "./OvertimePlannedWorkApproval.vue?vue&type=template&id=24b7d619"
import script from "./OvertimePlannedWorkApproval.vue?vue&type=script&lang=js"
export * from "./OvertimePlannedWorkApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports